// covered-by: frontends/carrie/src/ask-v2/project/__tests__/AskV2OpenItemRow.test.tsx
import { type AskPunttOpenItem } from "@mg/schemas/src/christo/askPunttOpenItems";

const LABEL = /\*\*\s*(issue|fix|reason|artwork shows)\s*:?\s*\*\*:?/gi;

export function openItemSeverity(item: AskPunttOpenItem): string {
  const value = item.severity;
  return typeof value === "string" ? value.trim() : "";
}

function labeledParts(needed: string): Map<string, string> {
  const indexes: { label: string; start: number; end: number }[] = [];
  const pattern = new RegExp(LABEL.source, "gi");
  let match: RegExpExecArray | null;
  while ((match = pattern.exec(needed)) !== null) {
    indexes.push({
      label: (match[1] ?? "").toLowerCase().replace(/\s+/g, " "),
      start: match.index,
      end: match.index + match[0].length,
    });
  }
  const parts = new Map<string, string>();
  for (let i = 0; i < indexes.length; i += 1) {
    const next = indexes[i + 1]?.start ?? needed.length;
    const text = needed.slice(indexes[i].end, next).replace(/\s+/g, " ").trim();
    if (text.length > 0 && !parts.has(indexes[i].label)) {
      parts.set(indexes[i].label, text);
    }
  }
  return parts;
}

// why: the issue section is the question. Leaving artwork and the fix in
// `needed` put the quoted line into the title's remainder.
export function findingIssueText(needed: string): string | null {
  const parts = labeledParts(needed);
  if (!parts.has("issue")) return null;
  return parts.get("issue") ?? "";
}

export function findingQuote(item: AskPunttOpenItem): string {
  if (item.kind !== "unjudged_finding") return "";
  return labeledParts(item.needed).get("artwork shows") ?? "";
}

export function findingSuggestion(item: AskPunttOpenItem): string {
  if (item.kind !== "unjudged_finding") return "";
  return labeledParts(item.needed).get("fix") ?? "";
}
